<template>
    <dl class="selector-card" :class="{'is-selected': isSelected}" @click="select()">
        <dt v-if="icon"><svg :class="icon"><use :xlink:href="`#provider-${icon}`"></use></svg></dt>
        <dt v-else>{{ title }}</dt>
        <dd>{{ label }}</dd>
    </dl><!-- end.selector-card -->
</template>

<script>
    export default {
        props: ['title', 'label', 'icon', 'isSelected'],
        methods: {
            select() {
                this.$emit('select');
            }
        }
    }
</script>